import React, { useEffect, useState } from "react";
import ProgressLayout from "../ProgressLayout";
import TitleManpower from "./TilteManpower";
import { useLocation, useParams } from "react-router-dom";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import { Modal, notification } from "antd";
import axiosInstance from "../../../../../../Services/axiosCommon";
import { useFormik } from "formik";
import {
  CancelButton,
  EditButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import Pagination from "../../../../../../Components/Utils/Pagenation";
import CreateManPowerTittlePro from "./CreateManPower";
import MultiEditManpowerPro from "./MultiEditManpowerpro";
import * as yup from "yup";
import { ExclamationCircleFilled } from "@ant-design/icons";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import UseGetDataSearchByPro from "../../../../../../Components/Hooks/useFetchDataByPRO";
import ImportManPower from "./import";
import UseDropDownRole from "../../../../../../Components/Hooks/UseRole";
import MobileManPowerPro from "../../../../../Mobile/ProjectSubmenu/Progress/Man Power/MobileManpower";
import UseCatSubCatDropDown from "../../../../../../Components/Hooks/useCategoryDropDown";

function ManpowerIndex() {
  const { value: Type, getData: refManPowerType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "ManPowerType"
  );
  const { data: Role } = UseDropDownRole(`/manpower-role/drop-down`);
  const location = useLocation();
  const searchQuery = location.state?.searchQuery;

  const { officeId } = useParams();
  const { projectId } = useParams();
  const [open, setOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const { confirm } = Modal;
  const [api, contextHolder] = notification.useNotification();
  const [multiEditOpen, setMultiEditOpen] = useState(false);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [selectedExpandedItems, setSelectedExpandedItems] = useState([]);
  const [flatSelectedItemIds, setFlatSelectedItemIds] = useState([]);

  const handleMainCheckboxChange = (titleId, items) => {
    setSelectedTitles((prevSelectedTitles) =>
      prevSelectedTitles.includes(titleId)
        ? prevSelectedTitles.filter((id) => id !== titleId)
        : [...prevSelectedTitles, titleId]
    );

    setSelectedExpandedItems((prevSelectedExpandedItems) => ({
      ...prevSelectedExpandedItems,
      [titleId]: selectedTitles.includes(titleId)
        ? [] // Clear items if main checkbox is deselected
        : items.map((item) => item.id), // Select all items if main checkbox is selected
    }));
  };

  const handleExpandedCheckboxChange = (titleId, itemId) => {
    setSelectedExpandedItems((prevSelectedExpandedItems) => ({
      ...prevSelectedExpandedItems,
      [titleId]: prevSelectedExpandedItems[titleId]?.includes(itemId)
        ? prevSelectedExpandedItems[titleId].filter((id) => id !== itemId)
        : [...(prevSelectedExpandedItems[titleId] || []), itemId],
    }));
  };

  useEffect(() => {
    const allSelectedIds = Object.values(selectedExpandedItems).flat();
    setFlatSelectedItemIds(allSelectedIds);
  }, [selectedExpandedItems]);

  const currentPage = location.state?.currentPage;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [filter, setFilter] = useState(false);

  const [filterProps, setFilterProps] = useState({
    type: "",
  });

  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    type: "",
  });
  const clearFilter = () => {
    setParams({ ...params, type: "" });
    formik.values.unit = "";
    setFilter(false);
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      setParams({ ...params, type: value.type });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        type: "",
      });
    },
  });
  const [valueOfSearch, setValuesofSearch] = useState("");
  function searchFunction(e) {
    setValuesofSearch(e?.target?.value);
    setParams({ ...params, search: e?.target?.value, page: 1 });
    setPage(1);
  }
  const { data, totalCount, getData, dataLoading } = UseGetDataSearchByPro(
    `/pro_manpower/new/${projectId}`,
    params
  );
  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);
  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const isTitleSelected = (titleId) => selectedTitles.includes(titleId);

  const handleDelete = async (id) => {
    confirm({
      title: `Do you Want to delete Man Power Items?`,
      centered: true,
      width: "25%",
      icon: <ExclamationCircleFilled />,
      content: `The Man Power Items will be removed from the Man Power`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        axiosInstance
          .delete(`/pro_manpower/multi-delete`, {
            headers: {
              "Content-Type": "application/json",
            },
            data: { ids: id }, // Pass the payload as the `data` key in `delete`
          })
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              getData();
              api.success({
                message: `Man Power Multi Item has deleted successfully`,
                description: res?.data?.msg || " ",
                placement: "bottomRight",
              });
            } else {
              api.error({
                message: `Man Power Multi Item has delete failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            api.error({
              message: `Man Power Multi Item has delete failed`,
              description:
                error?.response?.data?.msg || "Sever error (or) Network error",
              placement: "bottomRight",
            });
          });
      },
      onCancel() {},
    });
  };

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {contextHolder}
      <ProgressLayout
        setOpen={setOpen}
        onCreateClick={() => {
          setCreateModalOpen(true);
        }}
        isFilter={filter}
        setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        searchFun={searchFunction}
        searchValue={valueOfSearch}
        newfilter={true}
        officeId={officeId}
        searchQuery={searchQuery}
        neededSearch={true}
        projectId={projectId}
        ImportAccess={true}
      >
        <div className="w-full h-[calc(100vh-153px)] p-3 overflow-hidden">
          {screenSize.width <= "786" ? (
            <MobileManPowerPro
              Data={data}
              getData={getData}
              Role={Role}
              Type={Type}
            />
          ) : (
            <div className=" w-full h-[calc(100vh-195px)] overflow-y-scroll">
              {flatSelectedItemIds.length > 0 ? (
                <div className="w-full flex justify-end gap-2 py-2">
                  <EditButton
                    height="5"
                    value="Multi Edit"
                    handleClick={() => {
                      setMultiEditOpen(true);
                    }}
                  />
                  <button
                    type="button"
                    className="px-2 h-5 cursor-pointer text-xs text-red-500 bg-white rounded-md flex items-center"
                    style={{ border: "1px solid red" }}
                    onClick={() => {
                      handleDelete(flatSelectedItemIds);
                    }}
                  >
                    Multi Delete
                  </button>
                </div>
              ) : null}
              <table
                className="table-auto static top-0 w-full"
                style={{ border: "none", borderCollapse: "collapse" }}
              >
                <thead className=" w-full bg-white p-3 mt-4">
                  <tr className="text-xs border-b  font-medium  py-3">
                    {header.map((header, i) => (
                      <th
                        className={`py-3 ${header.width}  ${
                          header?.isLeft ? "text-left" : "text-center"
                        } font-medium text-xs 2xl:text-sm text-[#4F4768]`}
                        key={i}
                        style={{ border: "none", borderCollapse: "collapse" }}
                      >
                        {header.headone}
                      </th>
                    ))}
                  </tr>
                </thead>
              </table>

              <div
                className={` w-full pt-0.5 ${
                  flatSelectedItemIds.length > 0
                    ? "h-[calc(100vh-250px)]"
                    : "h-[calc(100vh-243px)]"
                }  overflow-y-auto relative`}
              >
                <table
                  className="table-auto  w-full"
                  style={{ border: "none", borderCollapse: "collapse" }}
                >
                  <tbody>
                    {data &&
                      data.map((item, i) => {
                        return (
                          <TitleManpower
                            data={item}
                            Role={Role}
                            // unit={Unit}
                            Type={Type}
                            getData={getData}
                            projectId={projectId}
                            selectedTitles={selectedTitles}
                            selectedExpandedItems={selectedExpandedItems}
                            onMainCheckboxChange={handleMainCheckboxChange}
                            onExpandedCheckboxChange={
                              handleExpandedCheckboxChange
                            }
                            isTitleSelected={isTitleSelected}
                            // refManPowerRole={refManPowerRole}
                            // refManPowerUnit={refManPowerUnit}
                          />
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className=" my-[2px] px-3">
            <Pagination
              total={totalCount}
              pageIndex={params.page}
              setPageIndex={setPage}
              dataCount={params.per_page}
              setDataCount={setPageCount}
            />
          </div>
        </div>
        <CreateManPowerTittlePro
          open={createModalOpen}
          onCancel={() => {
            setCreateModalOpen(false);
          }}
          getData={getData}
        />
        <MultiEditManpowerPro
          open={multiEditOpen}
          onCancel={() => {
            setMultiEditOpen(false);
          }}
          getData={getData}
          seletedIds={flatSelectedItemIds}
          projectId={projectId}
        />
      </ProgressLayout>
      <ImportManPower
        open={open}
        onCancel={() => setOpen(false)}
        getData={getData}
        label="Import"
        projectId={projectId}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter Manpower</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <FormikSelectTwo
                  label="Type"
                  width="w-full m"
                  formik={formik}
                  placeholder="Choose"
                  name="type"
                  Options={Type}
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ManpowerIndex;

const header = [
  // {
  //   headone: "ID",
  //   width: "w-[3%]",
  //   // isLeft: true,
  // },
  {
    headone: "Sl.No",
    width: "w-[5%]",
    isLeft: true,
  },

  {
    headone: "Role",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Type",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Planned Days",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Actual Days",
    width: "w-[10%]",
    isLeft: true,
  },

  {
    headone: "Budget  Qty. ",
    width: "w-[10%]",
    isLeft: true,
  },

  {
    headone: "Budget Price",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Actual  Qty. ",
    width: "w-[10%]",
    isLeft: true,
  },

  {
    headone: "Actual Price",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Amt.",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Action",
    width: "w-[5%]",
  },
];
